import type { Network, SelectedNetwork } from '@/types';
import { SelectEcho } from '@/components/echo/primitives';

type NetworksFilterProps = {
  networks: Network[];
  selectedNetwork: SelectedNetwork;
  onApply: (networkId: string) => void;
  onOpen?: () => void;
};

const NetworksFilter = ({
  networks = [],
  selectedNetwork,
  onApply,
  onOpen,
}: NetworksFilterProps) => {
  const displayLabel = selectedNetwork?.name ? `Network: ${selectedNetwork.name}` : 'Select a network';

  const options = networks.map((network) => ({
    value: network.id,
    label: network.name,
  }));

  return (
    <SelectEcho
      id="network-select"
      data-testid="network-select"
      showSearch={{
        optionFilterProp: "label"
      }}
      displayLabel={displayLabel}
      placeholder="Network"
      value={selectedNetwork?.id ?? ''}
      options={options}
      onClick={onOpen}
      onChange={(selectedValue) => {
        onApply(String(selectedValue));
      }}
    />
  );
};

export default NetworksFilter;
